
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import Slider from '@/components/form/Slider.vue';
import MenuEngineeringLogic from '@/logic/menu-engineering/MenuEngineeringLogic';
import { Dish, Restaurant } from '@/api/model';

@Component({
  components: { Slider },
})
export default class DishForm extends Vue {
  get sliders(): any[] {
    const sliders = [
      {
        field: 'popularity',
        label: 'menuEngineering.label.popularity',
        tooltip: 'menuEngineering.label.info.popularity',
        max: 300,
      },
      {
        field: 'costPrice',
        label: 'menuEngineering.label.cost',
        tooltip: 'menuEngineering.label.info.cost',
        max: 50,
      },
      {
        field: 'chefTime',
        label: 'menuEngineering.label.time',
        tooltip: 'menuEngineering.label.info.time',
        max: 10,
      },
      {
        field: 'staffTime',
        label: 'menuEngineering.label.helpTime',
        tooltip: 'menuEngineering.label.info.helpTime',
        max: 15,
      },
      {
        field: 'price',
        label: 'menuEngineering.label.price',
        tooltip: 'menuEngineering.label.info.price',
        max: 200,
      },
    ];
    if (this.isLandingPage) {
      sliders.push({
        field: 'companyStaffSize',
        label: 'menuEngineering.label.companyStaffSize',
        tooltip: 'menuEngineering.label.info.companyStaffSize',
        max: 300,
      });
      sliders.push({
        field: 'companySeatCount',
        label: 'menuEngineering.label.companySeatCount',
        tooltip: 'menuEngineering.label.info.companySeatCount',
        max: 300,
      });
    }

    return sliders;
  }

  courses?: string[];

  @Prop(Object)
  value!: Dish;

  @Prop(Array)
  restaurants!: Restaurant[];

  @Prop(Boolean)
  showResultsButton!: boolean;

  @Prop(Boolean)
  saving!: boolean;

  @Prop({ default: false })
  isLandingPage!: boolean;

  @Emit()
  input(dish: Dish): Dish {
    return dish;
  }

  @Emit()
  submit() {}

  get restaurantId(): string {
    if (this.value.restaurantId) {
      return this.value.restaurantId;
    }
    if (this.restaurants && this.restaurants.length && this.restaurants[0].id) {
      this.setField('restaurantId', this.restaurants[0].id);
      return this.restaurants[0].id;
    }

    return '';
  }

  get submitLabel(): string {
    if (this.isLandingPage) {
      return 'menuEngineering.overview.calculateNow';
    }

    return this.value.id
      ? 'menuEngineering.overview.save'
      : 'menuEngineering.overview.addAnotherDish';
  }

  beforeCreate() {
    this.courses = MenuEngineeringLogic.getCourses();
  }

  setField(name: string, value: string | number) {
    if (name === 'course') {
      this.$store.commit('menuEngineering/setActiveCourse', value);
    }
    if (name === 'restaurantId') {
      this.$store.commit('restaurant/setActiveRestaurantId', value);
    }
    const dish: any = this.value;
    dish[name] = value;
    this.input(dish);
  }

  toResults() {
    this.$router.push('/menu-engineering/results');
  }
}
